export default __webpack_public_path__ + "static/media/reserve_pc@2x.74011cfd.jpg";